import { Box, IconButton, Text } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { ChevronLeftSmall, ChevronRightSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback } from 'react';
import { dataHooks } from '../../../../../utils/datahooks';
export const Pagination = _ref => {
  let {
    pageSize,
    totalItems,
    currentPageNumber,
    onClickNext,
    onClickBack,
    pagesAmount,
    datahook
  } = _ref;
  const getEndPageIndex = useCallback(() => {
    const endIndex = currentPageNumber * pageSize + pageSize;
    return endIndex > totalItems ? totalItems : endIndex;
  }, [currentPageNumber, pageSize, totalItems]);
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.altTextPaginationContainer(datahook),
    verticalAlign: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    marginTop: "4px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      grey: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        light: true,
        secondary: true
      })
    },
    i18nKey: "accessibility-wizard.alt-text.elements-list.element-indexes",
    values: {
      endIndex: getEndPageIndex(),
      startIndex: currentPageNumber * pageSize + 1,
      totalAmount: totalItems
    }
  }))), /*#__PURE__*/React.createElement(Box, {
    gap: "9px"
  }, /*#__PURE__*/React.createElement(IconButton, {
    dataHook: dataHooks.altTextPaginationBackButton(datahook),
    disabled: currentPageNumber === 0,
    priority: "secondary",
    size: "tiny",
    skin: "standard",
    onClick: onClickBack
  }, /*#__PURE__*/React.createElement(ChevronLeftSmall, null)), /*#__PURE__*/React.createElement(IconButton, {
    dataHook: dataHooks.altTextPaginationNextButton(datahook),
    disabled: currentPageNumber + 1 === pagesAmount,
    priority: "secondary",
    size: "tiny",
    skin: "standard",
    onClick: onClickNext
  }, /*#__PURE__*/React.createElement(ChevronRightSmall, null))));
};
//# sourceMappingURL=pagination.js.map